export const VIEW_TYPES = Object.freeze({
  List: { key: "list", value: (t) => t("main_view.list") },
  Calendar: { key: "calendar", value: (t) => t("main_view.calendar") }
});

export const CALENDAR_MONTH_VIEW = "month";
export const CALENDAR_WEEK_VIEW = "week";
